var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag01Bulk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.41144 4.68911C10.2484 3.85219 11.4043 3.41786 12.5759 3.50011L16.5402 3.77844C18.5196 3.91741 20.0826 5.48041 20.2216 7.45987L20.4999 11.4242C20.5822 12.5958 20.1478 13.7517 19.3109 14.5886L12.7456 21.154C11.1622 22.7373 8.61235 22.7545 7.05026 21.1924L2.80762 16.9498C1.24552 15.3877 1.26274 12.8378 2.84608 11.2545L9.41144 4.68911Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8284,
    cy: 9.17169,
    r: 2,
    transform: "rotate(45 14.8284 9.17169)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag01Bulk);
export default __webpack_public_path__ + "static/media/tag01Bulk.347da3e1a3732725f1627577bea72bd4.svg";
export { ForwardRef as ReactComponent };